if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail) {
              activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        // --- ADD THIS CALL HERE ---
        this.updateDots();

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          // const activeMediaRect = activeMedia.getBoundingClientRect();
          // if (activeMediaRect.top > -0.5) return;
          // const top = activeMediaRect.top + window.scrollY;
          // window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (!activeThumbnail) return;
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      updateDots() {
        const dotsContainer = this.querySelector('.slider-counter--dots');
        if (!dotsContainer) return;

        const slides = Array.from(this.elements.viewer.querySelectorAll('.slider__slide'));
        const visibleSlides = slides.filter(slide => window.getComputedStyle(slide).display !== 'none');
        const dots = Array.from(dotsContainer.querySelectorAll('.slider-counter__link--dots'));

        // 1. Ensure there are enough dot elements for visible slides
        while (dots.length < visibleSlides.length) {
          const newDot = document.createElement('button');
          newDot.type = 'button';
          newDot.className = 'slider-counter__link slider-counter__link--dots';
          newDot.setAttribute('name', 'pager');
          newDot.innerHTML = '<span class="dot"></span>';

          dotsContainer.appendChild(newDot);
          dots.push(newDot);
        }

        // 2. Re-bind click handlers for ALL dots so indices stay accurate
        dots.forEach((dot, index) => {
          // Clone and replace to clear old event listeners
          const cleanDot = dot.cloneNode(true);
          dot.parentNode.replaceChild(cleanDot, dot);
          dots[index] = cleanDot;

          cleanDot.addEventListener('click', (e) => {
            e.preventDefault();
            if (visibleSlides[index]) {
              visibleSlides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            }
          });

          if (index < visibleSlides.length) {
            cleanDot.style.display = 'inline-block';
            cleanDot.classList.toggle('slider-counter__link--active', index === 0);
          } else {
            cleanDot.style.display = 'none';
            cleanDot.classList.remove('slider-counter__link--active');
          }
        });

        // 3. Attach a scroll listener to keep the active dot filled as you swipe
        const slider = this.elements.viewer.querySelector('.slider');
        if (slider && !slider.dataset.dotsScrollBound) {
          slider.dataset.dotsScrollBound = 'true'; // Prevent duplicate listeners
          let isScrolling;

          slider.addEventListener('scroll', () => {
            clearTimeout(isScrolling);
            isScrolling = setTimeout(() => {
              const currentVisible = Array.from(this.elements.viewer.querySelectorAll('.slider__slide'))
                .filter(slide => window.getComputedStyle(slide).display !== 'none');
              const currentDots = Array.from(dotsContainer.querySelectorAll('.slider-counter__link--dots'))
                .filter(dot => window.getComputedStyle(dot).display !== 'none');

              if (!currentVisible.length || !currentDots.length) return;

              const scrollPosition = slider.scrollLeft;
              const slideWidth = currentVisible[0].offsetWidth;
              // Clamp the active index so the final dot always activates on full scroll
              let activeIndex = Math.round(scrollPosition / slideWidth);
              if (activeIndex >= currentDots.length) activeIndex = currentDots.length - 1;

              currentDots.forEach((d, i) => {
                d.classList.toggle('slider-counter__link--active', i === activeIndex);
              });
            }, 50);
          });
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
